// Centralized site configuration. Update these values to change content
// across the entire site — every component reads from here.

export const assets = {
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_benji-cleanup/artifacts/mpdkdhga_Untitled%20design%20-%202026-08-09T072101.955.png",
  benji: "https://customer-assets-agu9un31.emergentagent.net/job_benji-cleanup/artifacts/z91mjs9g_IMG_7958.webp",
};

export const business = {
  name: "Benji's Hauling & Junk Removal",
  shortName: "Benji's Hauling",
  tagline: "Loyal service. Cleaner spaces.",
  phoneDisplay: "(503) 884-3620",
  phoneHref: "+15038843620",
  email: "benjisjunkhauling@gmail.com",
  city: "Salem",
  state: "OR",
  serviceArea: "Salem & surrounding areas",
  hoursSummary: "Open Mon–Sat • Closed Sun",
  social: {
    instagram: "https://www.instagram.com/benjis.haulingandjunk.removal?igsh=MXZqZW92ZGowa250YQ%3D%3D&utm_source=qr",
    facebook: "https://www.facebook.com/share/1HVDrFyTDL/?mibextid=wwXIfr",
  },
  startingPrice: 99,
};

export const telLink = `tel:${business.phoneHref}`;
export const smsLink = `sms:${business.phoneHref}`;

export const hoursList = [
  { day: "Sunday", time: "Closed" },
  { day: "Monday", time: "8:00 AM – 6:00 PM" },
  { day: "Tuesday", time: "8:00 AM – 6:00 PM" },
  { day: "Wednesday", time: "6:30 AM – 7:30 PM" },
  { day: "Thursday", time: "6:30 AM – 7:30 PM" },
  { day: "Friday", time: "6:30 AM – 7:30 PM" },
  { day: "Saturday", time: "6:30 AM – 6:00 PM" },
];

export const serviceAreaCities = [
  "Salem", "Stayton", "Sublimity", "Lyons", "Independence",
  "Albany", "Jefferson", "Woodburn", "Aumsville", "Turner", "Dallas",
];

export const serviceAreaDisclaimer = {
  intro: "If your project site is beyond 30 miles from Salem, just let us know! Special accommodations can usually be made to suit your project, and your wallet.",
  note: "Extra fees may vary depending on how far you are outside our service area.",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Pricing", to: "/pricing" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const trustPoints = [
  { icon: "check", label: "Free Estimates" },
  { icon: "check", label: "Upfront Pricing" },
  { icon: "check", label: "Fast & Friendly Service" },
  { icon: "check", label: "Responsible Disposal" },
  { icon: "check", label: "Locally Owned" },
  { icon: "paw", label: "Dog-Friendly Bonus" },
];

export const services = [
  { slug: "furniture-removal", icon: "Sofa", title: "Furniture Removal", blurb: "Couches, mattresses, tables, chairs, dressers, shelving, and other unwanted furniture." },
  { slug: "appliance-removal", icon: "Refrigerator", title: "Appliance Removal", blurb: "Refrigerators, washers, dryers, stoves, dishwashers, and other unwanted appliances where permitted." },
  { slug: "garage-cleanouts", icon: "Warehouse", title: "Garage Cleanouts", blurb: "Clear accumulated clutter, boxes, old furniture, tools, and unwanted household items." },
  { slug: "basement-cleanouts", icon: "Boxes", title: "Basement Cleanouts", blurb: "Remove unwanted furniture, storage items, boxes, debris, and years of accumulated clutter." },
  { slug: "attic-cleanouts", icon: "Home", title: "Attic Cleanouts", blurb: "Make unused attic spaces manageable again by removing unwanted stored items." },
  { slug: "estate-cleanouts", icon: "HandHeart", title: "Estate Cleanouts", blurb: "Respectful, efficient help clearing homes and properties during transitions." },
  { slug: "property-cleanouts", icon: "Building2", title: "Property Cleanouts", blurb: "Whole-home, rental-property, apartment, storage-area, and property cleanouts." },
  { slug: "moving-cleanouts", icon: "Package", title: "Moving Cleanouts", blurb: "Remove the things that aren't making the move with you." },
  { slug: "yard-debris-removal", icon: "TreePine", title: "Yard Debris Removal", blurb: "Branches, brush, outdoor debris, and other approved yard waste." },
  { slug: "construction-debris", icon: "Hammer", title: "Construction & Renovation Debris", blurb: "Removal of approved non-hazardous renovation and construction materials." },
  { slug: "commercial-cleanouts", icon: "Briefcase", title: "Office & Commercial Cleanouts", blurb: "Furniture, office equipment, shelving, and unwanted business contents." },
  { slug: "single-item-pickup", icon: "Truck", title: "Single Item Pickup", blurb: "For customers who only need one unwanted bulky item removed." },
];

export const pricing = [
  { size: "Single Item / Minimum Load", volume: "Up to ½ yd³", price: 99 },
  { size: "1 Yard", volume: "1 yd³", price: 150 },
  { size: "2 Yards", volume: "2 yd³", price: 225 },
  { size: "3 Yards", volume: "3 yd³", price: 310 },
  { size: "4 Yards", volume: "4 yd³", price: 385 },
  { size: "5 Yards", volume: "5 yd³", price: 450 },
  { size: "6 Yards", volume: "6 yd³", price: 505 },
  { size: "7 Yards", volume: "7 yd³", price: 550 },
  { size: "Full Truck", volume: "8 yd³", price: 580 },
];

export const priceIncludes = [
  { icon: "paw", label: "Loading & labor" },
  { icon: "Truck", label: "Hauling & transportation" },
  { icon: "Recycle", label: "Responsible disposal & recycling whenever possible" },
  { icon: "Ruler", label: "Free estimates" },
  { icon: "Sparkles", label: "Sweep-up before we leave" },
  { icon: "Bone", label: "A complimentary treat bag for your furry friend!" },
];

export const howItWorks = [
  { step: "1", title: "Tell Us What Needs to Go", body: "Call, text, or submit the free estimate form. For the fastest quote, upload or send us a few photos of the items." },
  { step: "2", title: "Get Your Estimate", body: "We provide straightforward pricing based primarily on the amount of truck space your junk requires." },
  { step: "3", title: "We Haul It Away", body: "Our team loads everything, hauls it away, responsibly disposes or recycles whenever possible, and sweeps the area before leaving." },
];

export const whyChoose = [
  { icon: "Ruler", title: "Free Estimates", body: "Know what to expect before the work begins." },
  { icon: "Smile", title: "Friendly Service", body: "Professional service without the corporate feel." },
  { icon: "Tag", title: "Straightforward Pricing", body: "Simple volume-based starting prices." },
  { icon: "Truck", title: "Full-Service Removal", body: "We handle the lifting, loading, hauling, and cleanup." },
  { icon: "Recycle", title: "Responsible Disposal", body: "We recycle or responsibly dispose of materials whenever possible." },
  { icon: "Sparkles", title: "Sweep-Up Included", body: "We don't leave behind a mess after removing yours." },
  { icon: "Bone", title: "Benji's Dog Treat Bonus", body: "A complimentary treat bag for customers' furry friends." },
];

export const promises = [
  "Show up ready to work",
  "Respect your home and property",
  "Communicate clearly",
  "Provide straightforward estimates",
  "Work efficiently",
  "Leave the space tidy",
  "Dispose of items responsibly whenever possible",
];

export const beforeAfter = [
  { title: "Garage Cleanout", img: "https://images.unsplash.com/photo-1635108198854-26645ffe6714?auto=format&fit=crop&w=800&q=70" },
  { title: "Property Cleanout", img: "https://images.unsplash.com/photo-1772544376426-6a42f1dfa74a?auto=format&fit=crop&w=800&q=70" },
];

export const faqs = [
  { q: "How much does junk removal cost?", a: "Pricing starts at $99 and depends primarily on how much space your items take up in our truck. Heavy or specialty materials such as concrete, dirt, brick, and roofing may be priced differently because of added weight and disposal costs. The best way to know is a free estimate." },
  { q: "Do you offer free estimates?", a: "Yes. Estimates are always free. You can call, text, or submit the online estimate form and we'll help you figure out the best option." },
  { q: "Can I text you photos for an estimate?", a: "Absolutely. Sending a few clear photos of the items you want removed is the fastest way for us to give you an accurate estimate." },
  { q: "Do I need to move the junk outside?", a: "No. Full-service junk removal generally includes the loading, so you don't have to lift a thing. Keep in mind that accessibility can affect pricing." },
  { q: "What types of junk do you remove?", a: "Furniture, general household junk, cleanout items, appliances where accepted, yard debris, approved renovation debris, and much more. Don't see your item? Send us a photo and ask." },
  { q: "Do you remove just one item?", a: "Yes. Single-item and minimum-load service starts at $99, so we're happy to grab that one bulky item you need gone." },
  { q: "Do you recycle or donate items?", a: "Whenever it's practical, we look for responsible options rather than sending everything to the landfill. This depends on the item's condition and local availability." },
  { q: "Do you remove concrete, dirt, brick, or roofing materials?", a: "These heavy materials may require separate pricing because of their weight and disposal fees. Contact us for an estimate so we can give you accurate information." },
  { q: "Are there items you cannot take?", a: "Some hazardous, regulated, or restricted materials may not be accepted. If you're unsure about an item, contact us first and we'll let you know." },
  { q: "Why do customers receive dog treats?", a: "Our company is inspired by a loyal golden retriever named Benji. As a small thank-you, customers with a dog at home can receive a complimentary treat bag with their booked service." },
  { q: "Do I need to be home?", a: "Access and appointment details vary by job, so please contact us to discuss what works best for your situation. We'll make the process simple and clear." },
];
